import styled, { css } from 'styled-components'

import { red } from '../../styles/colors'

export const Wrap = styled.div`
  width: 1rem;
  height: 1rem;
  position: relative;
  display: block;
  padding: 0;
  outline: 0;
  cursor: pointer;

  ${props =>
    props.active &&
    css`
      ${Vertical} {
        height: 0;
      }
    `};
`

export const Vertical = styled.div`
  position: absolute;
  width: 2px;
  height: 100%;
  left: calc(50% - 1px);
  top: 0;
  transition: height 0.25s;
  background: ${red};
`

export const Horizontal = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  top: calc(50% - 1px);
  left: 0;
  transition: width 0.5s;
  background: ${red};
`



// WEBPACK FOOTER //
// ./src/components/PlusMinus/styles.js